import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GeneralSkeleton.tsx");
